/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { lazy } from "react";
import { withChunkRetry } from "@shared/utils/chunk-retry";

// Lazy load feature-flagged components to enable tree-shaking
export const DesignSystemPage = lazy(
  withChunkRetry(() => import("@features/design-system/pages/DesignSystemPage"))
);
export const EarlyAccessPage = lazy(
  withChunkRetry(() => import("@features/early-access/pages/EarlyAccessPage"))
);
export const ZustandTest = lazy(
  withChunkRetry(() => import("@pages/other/zustand-test"))
);
export const UnderDevelopmentPage = lazy(
  withChunkRetry(() => import("@pages/authenticated/agency-pages/UnderDevelopmentPage"))
);
export const AgencyDashboardLayout = lazy(
  withChunkRetry(() => import("@layout/agency/AgencyDashboardLayout"))
);
export const AcceptInvitePage = lazy(
  () => import("@pages/authenticated/agency-pages/AcceptInvite")
);
export const SubscribePage = lazy(
  withChunkRetry(() => import("@features/subscription/pages/SubscribePage"))
);
export const Landing = lazy(() => import("@pages/unauthenticated/landing"));
export const PricingPage = lazy(
  withChunkRetry(() => import("@pages/public/PricingPage"))
);
export const CheckoutSuccessPage = lazy(
  withChunkRetry(() => import("@features/onboarding/pages/CheckoutSuccessPage"))
);

export const UserProfile = lazy(
  withChunkRetry(() => import("@pages/authenticated/user-pages/Profile"))
);
export const UserSecurity = lazy(
  withChunkRetry(() => import("@pages/authenticated/user-pages/Security"))
);
export const UserPreferences = lazy(
  withChunkRetry(() => import("@pages/authenticated/user-pages/Preferences"))
);
export const UserHelp = lazy(
  withChunkRetry(() => import("@pages/authenticated/user-pages/Help"))
);
export const UserWhatsApp = lazy(
  withChunkRetry(() => import("@pages/authenticated/user-pages/WhatsApp"))
);

export const AgencySiteConfigPage = lazy(
  withChunkRetry(() => import("@features/agency-site-config/components/AgencySiteConfigPage"))
);

export const SpreadsheetsHubPage = lazy(
  withChunkRetry(() => import("@features/spreadsheets/pages/SpreadsheetsHubPage"))
);
export const ImportSpreadsheetPage = lazy(
  withChunkRetry(() => import("@features/spreadsheets/pages/ImportSpreadsheetPage"))
);
export const AgentCapabilitiesPage = lazy(
  withChunkRetry(() => import("@features/agent-docs/pages/AgentCapabilitiesPage"))
);

export const AssistantPage = lazy(
  withChunkRetry(() => import("@features/assistant/pages/AssistantPage"))
);
